import Applicant from '@/components/services/SecuringEvidence/Applicant/Manual/index.vue';

import Url from '@/components/services/SecuringEvidence/Url.vue';
import Notificants from '@/components/services/SecuringEvidence/Notificants/index.vue';
import AccountBankDetails from '@/components/services/SecuringEvidence/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [
  Url,
  Notificants,
  AccountBankDetails,
  StepDocuments,
];
const steps: unknown[] = [Applicant, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const securingEvidenceSteps: unknown[] = isMrpaEnable(StatementType.SECURING_EVIDENCE) ? mrpaSteps : steps;
